export default __webpack_public_path__ + "static/media/verify-icon.4a7f09fd.svg";